<template>
    <admin-layout>    
        <div class="content" slot="main">
            <div class="col-xs-12 col-md-6">
                <div class="content-header">
                    <h3>Tags <button type="button" class="btn btn-custom" @click="toggleShowTagModal"><i class="fa fa-plus"></i> Add New</button>
                    </h3>
                </div>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in tagList">
                            <th><a href="#" v-on:click.stop.prevent="toggleShowTagModal(item)">{{item.name}}</a></th>
                            <td>{{ item.description }}</td>
                            <td class="text-right" width="120">
                                <button class="btn btn-default"
                                        role="button"
                                    v-on:click="removeTag(item.id)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="content-header">
                    <h3>Tag Rules <button type="button" class="btn btn-custom" @click="toggleShowTagRuleModal()"><i class="fa fa-plus"></i>&nbsp;Add Rule</button>
                    </h3>
                </div>
                
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Definition</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in tagRuleList">
                            <th><a href="#" v-on:click.stop.prevent="toggleShowTagRuleModal(item)">{{item.name}}</a></th>
                            <td>{{ item.description }}</td>
                            <td class="text-right" width="120">
                                <button class="btn btn-default"
                                        role="button"
                                    v-on:click="removeRule(item.id)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div slot="modals">
            <tag-modal v-if="showTagModal" :tag="tag" @close="closeTagModal">
            </tag-modal>
            <tag-rule-modal :rule="rule" :tags="tagList" v-if="showTagRuleModal" @close="closeTagRuleModal">
            </tag-rule-modal>
        </div> 
    </admin-layout>
</template>

<script>
 import Vue from 'vue';
 import {AdminLayout} from 'components/layouts/';
 import {TagModal, TagRuleModal} from 'components/modals/';
 
 // Load the full build. 
 var _ = require('lodash');
 
 export default {
     components: { 
         AdminLayout,
         TagRuleModal,
         TagModal
     },
     data () {
         return {
             loading: false,             
             tag: null,
             rule: null,
             tagList: [],
             tagRuleList: [],
             showTagModal: false,
             showTagRuleModal: false
         };
     },
     
     created () {
         this.fetchInitialData();
     },
     
     methods: {
         fetchInitialData () {
             this.fetchTags();
             this.fetchRules();
         },
         fetchTags () {
             var self = this;
             API.tags.getList()
                .then(function (response) {
                    self.tagList = response.data.results;
                });
         },
         fetchRules () {
             var self = this;
             API.tags.getRuleList()
                .then(function (response) {
                    self.tagRuleList = response.data.results;
                });
         },
         toggleShowTagModal (tagModel) {
             if (tagModel !== undefined) {
                 this.tag = Vue.leadscorz.deep_clone(tagModel);
             } else {
                 this.tag = { id: '', name: '' };
             }
             this.showTagModal = true;
         },
         toggleShowTagRuleModal (ruleModel) {
             if (ruleModel !== undefined) {
                 this.rule = ruleModel;
             } 
             this.showTagRuleModal = true;
         },
         closeTagModal (refresh) {
             this.tag = undefined;
             this.showTagModal = false;
             
             if (refresh) {
                 this.fetchTags();
             }
         },
         closeTagRuleModal (refresh) {
             this.tag = undefined;
             this.showTagModal = false;
             
             if (refresh) {
                 this.fetchRules();
             }
             this.showTagRuleModal = false;
         },
         removeTag (tagId) {
             var self = this; 
             var r = confirm("This action will be permanently and it can't be recovered. Are you sure you want to continue?");
             if (r === true) {
                 API.tags.delete(tagId)
                    .then(function () {
                        self.fetchTags();
                    },
                    (error) => {
                        Vue.toast('The tag cannot be deleted', {className: ['et-error']});
                    });
             }
         },
         removeRule (ruleId) {
             var self = this; 
             var r = confirm("This action will be permanently and it can't be recovered. Are you sure you want to continue?");
             if (r === true) {
                 API.tags.deleteRule(ruleId)
                    .then(function () {
                        self.fetchRules();
                    },
                    (error) => {
                        Vue.toast('The tag cannot be deleted', {className: ['et-error']});
                    });
             }
         },
     }
 }
</script>
<style scoped>
 .content > div  {
     padding-right: .5rem;
 }

 .content > div + div {
     padding-left: .5rem;
     padding-right: initial;
 }
</style>



// WEBPACK FOOTER //
// TagsSettings.vue?5f5b9967